import { useEffect } from 'react';
import { skinCssVars, skinFontsUrl, type SkinTokens } from '@blauturquesa/shared/skins';

/**
 * Aplica la skin d'una casa (§10) mentre la pàgina és oberta: les variables CSS van a l'arrel, de manera
 * que la capçalera i la navbar també prenen la personalitat de la casa, i en sortir es restauren les de
 * la base. Només es carreguen les tipografies d'aquesta skin. La transició suau és al CSS
 * (sense transició amb `prefers-reduced-motion`).
 */
export function useSkin(tokens: SkinTokens | undefined): void {
  useEffect(() => {
    if (!tokens) return;
    const root = document.documentElement;
    const vars = skinCssVars(tokens);
    const previous = Object.keys(vars).map((k) => [k, root.style.getPropertyValue(k)] as const);
    for (const [k, v] of Object.entries(vars)) root.style.setProperty(k, v);
    root.dataset['skin'] = tokens.mode;
    const url = skinFontsUrl(tokens);
    let link: HTMLLinkElement | null = null;
    if (url && !document.querySelector(`link[href="${url}"]`)) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      document.head.appendChild(link);
    }
    return () => {
      for (const [k, v] of previous) {
        if (v) root.style.setProperty(k, v);
        else root.style.removeProperty(k);
      }
      delete root.dataset['skin'];
      // El full de tipografies es queda: si es torna a la casa, ja és a la memòria cau.
    };
  }, [tokens]);
}
